import { Decorators, TemplatedDialog } from "@serenity-is/corelib";

@Decorators.registerClass('Watersource.Common.DroughtMapDisclaimerDialog')
@Decorators.panel(false)
export class DroughtMapDisclaimerDialog<P = {}> extends TemplatedDialog<P> {

    protected getDialogOptions() {
        var opt = super.getDialogOptions();
        opt.buttons = [
            {
                text: "Close",
                click: () => {
                    this.setCookie("DroughtMapDisclaimer", "true");
                    this.dialogClose();
                }
            }
        ];

        return opt;
    }

    private setCookie(name: string, val: string) {
        const date = new Date();
        const value = val;

        date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
        document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
    }

    public okClick: () => void;

    protected getTemplate() {
        return `
            <style>
            p {
                font-size: 16px;
                font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
            }
            </style>
            <div style="margin:20px;">

            <div class="title">
                <img src="/Content/site/images/watersource-full-logo-128.png" alt="Watersource Logo" />
            </div>        
        
            <div style="margin-top:20px;">
                <h3>Drought Map</h3>

                <p>
                    Hello, we’re so happy that you are taking an interest in this!
                </p>
                <p>
                    The Wheatley Watersource Drought Map aims to give a UK-wide view of the current status and availability of water resources to meet demand by Water Resource Zone (WRZ).  Providing a channel for water companies to share additional information, advice and notification of any water use restrictions that are in place due to dry weather events.
                </p>
                <p>
                    If you have a question, our Head of Water Solutions, Simon Murray is on hand to help, just email <a href="mailto:simon.murray@wheatleysolutions.co.uk">simon.murray@wheatleysolutions.co.uk</a> for a speedy response.
                </p>
            </div>
        </div>
        `;
    }
}
